import { ConfigItem } from 'Core/interfaces'
import { ConfigFilterItem } from 'Core/interfaces/filters'

export enum ReportsLogFilterFields {
	onlyMyReports = 'onlyMyReports',
	startDate = 'startDate',
	endDate = 'endDate',
	status = 'status'
}

export enum ReportLogsSearchResultFields {
	searchByReportName = 'searchByReportName'
}

export declare namespace ReportLog {
	interface Basic {
		reportLogId: number
		reportName: string | null
		user: string | null
		runDate: string
		status: string | null
		fileName: string | null
	}

	namespace Search {
		interface Config {
			[ReportLogsSearchResultFields.searchByReportName]: ConfigItem<ReportLogsSearchResultFields>
		}
	}

	namespace Filter {
		interface Config {
			[ReportsLogFilterFields.startDate]: ConfigFilterItem<string, null>
			[ReportsLogFilterFields.endDate]: ConfigFilterItem<string, null>
			[ReportsLogFilterFields.status]: ConfigFilterItem<string, string>
			[ReportsLogFilterFields.onlyMyReports]: ConfigFilterItem<string, boolean>
		}
	}
}
